/* ---- HGV cart offers: shared by the slide cart and the cart page ----
   Moved out of assets/cart-drawer.js. Loaded (defer) by snippets/cart-drawer.liquid AND
   sections/hg-cart-page.liquid; on /cart both tags are present, so the module guards itself
   with window.hgCartOffersLoaded and binds exactly once.

   Every handler is scoped to the nearest [data-hg-cart-root]:
     #CartDrawer                     context 'drawer', ids CartDrawer-*, items <cart-drawer-items>
     section.hg-cart-page            context 'page',   ids CartPage-*,   items <hg-cart-page-items>

   - [data-hg-switch]: POST /cart/change with {line, quantity, selling_plan}. Only that
     line changes; every other line is untouched, so a failure can never empty the cart.
     The drawer re-renders from the cart-drawer section exactly as before; the page
     re-renders its own section (hg-cart-page-items.hgRender) and syncs the header icon.
   - [data-hg-addone]: steps a one-time line up by one bottle through the context's
     updateQuantity (CartDrawerItems / HgCartPageItems).
   - [data-hg-keep]: hides the 30-Day card for this browser session (both contexts).
   One shared lock covers every offer button. Errors render inline; nothing is wiped.
   Guards kept from be53519: window.hgCartSwitching blocks stepper edits during a switch,
   hgCartSeq / hgUpdatedAt drops stale debounced changes, a switch never starts while the
   context's line list is disabled (another update in flight), 15s timeout, refocus on
   error, lock released on every path; checkout cleans invalid typed quantities.
   Tracking: window.dataLayer events hg_cart_offer_view / _click / _success / _error,
   hg_cart_offer_keep, hg_cart_nudge_click — each carries context: 'drawer' | 'page'. */
(function () {
  if (window.hgCartOffersLoaded) return;
  window.hgCartOffersLoaded = true;

  var busy = false;
  var KEEP_KEY = 'hg_cart_keep_30';
  var ROOT = '[data-hg-cart-root]';
  var ITEMS = 'cart-drawer-items, hg-cart-page-items';

  function track(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var k in data) payload[k] = data[k];
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  function cents(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? null : n / 100;
  }

  // Which cart a node belongs to.
  function contextOf(root) {
    return root && root.closest('cart-drawer') ? 'drawer' : 'page';
  }
  function prefixOf(ctx) {
    return ctx === 'drawer' ? 'CartDrawer' : 'CartPage';
  }

  function hideKeptCard() {
    var kept = false;
    try { kept = sessionStorage.getItem(KEEP_KEY) === '1'; } catch (e) {}
    if (!kept) return;
    document.querySelectorAll(ROOT + ' [data-hg-offer="30to90"]').forEach(function (el) { el.hidden = true; });
  }

  function reportOffersShown(root) {
    if (!root) return;
    var ctx = contextOf(root);
    hideKeptCard();
    root.querySelectorAll('[data-hg-switch]').forEach(function (btn) {
      if (btn.closest('[hidden]')) return;
      track('hg_cart_offer_view', { offer: btn.dataset.kind === '30' ? '30_to_90' : 'onetime_to_90', context: ctx });
    });
  }

  function renderDrawerFromSection(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.drawer__inner');
    var current = document.querySelector('#CartDrawer .drawer__inner');
    if (!fresh || !current) return false;
    current.innerHTML = fresh.innerHTML;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var empty = !current.querySelector('tr.cart-item');
      drawer.classList.toggle('is-empty', empty);
      var focusTarget = current.querySelector('.cart-item__name') || current.querySelector('.drawer__close');
      if (typeof trapFocus === 'function') trapFocus(drawer, focusTarget);
    }
    hideKeptCard();
    return true;
  }

  // Page: hg-cart-page-items owns its own section render (sections/hg-cart-page.liquid).
  function renderPageFromSection(items, html) {
    if (!items || typeof items.hgRender !== 'function') return false;
    var ok = items.hgRender(html);
    if (ok) hideKeptCard();
    return ok;
  }

  function showError(btn, msg) {
    var scope = btn.closest('[data-hg-switch-wrap], [data-hg-offer]') || btn.closest(ROOT);
    var el = scope && scope.querySelector('[data-hg-switch-error]');
    if (el) {
      el.textContent = msg;
      el.hidden = false;
    }
  }

  function setLoading(btn, on) {
    btn.toggleAttribute('disabled', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.classList.toggle('is-loading', on);
  }

  document.addEventListener('click', function (e) {
    // Keep 30-Day
    var keep = e.target.closest(ROOT + ' [data-hg-keep]');
    if (keep) {
      e.preventDefault();
      try { sessionStorage.setItem(KEEP_KEY, '1'); } catch (err) {}
      var card = keep.closest('[data-hg-offer]');
      if (card) card.hidden = true;
      track('hg_cart_offer_keep', { offer: '30_to_90', context: contextOf(keep.closest(ROOT)) });
      return;
    }

    // Add one more bottle (one-time line)
    var add = e.target.closest(ROOT + ' [data-hg-addone]');
    if (add) {
      e.preventDefault();
      if (busy) return;
      var items = add.closest(ITEMS);
      if (!items || typeof items.updateQuantity !== 'function') return;
      // The line's own quantity input (drawer: #Drawer-quantity-N, page: #Page-quantity-N).
      var qtyInput = items.querySelector('.quantity__input[data-index="' + add.dataset.line + '"]');
      var nextQty = qtyInput ? (parseInt(qtyInput.value, 10) || 0) + 1 : parseInt(add.dataset.qty, 10);
      track('hg_cart_nudge_click', { to_qty: nextQty, context: contextOf(add.closest(ROOT)) });
      if (qtyInput) qtyInput.value = nextQty;
      items.updateQuantity(add.dataset.line, nextQty, e, 'plus', add.dataset.variantId);
      return;
    }

    // Switch a line to the 90-Day plan
    var btn = e.target.closest(ROOT + ' [data-hg-switch]');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;
    var root = btn.closest(ROOT);
    var ctx = contextOf(root);
    var prefix = prefixOf(ctx);
    var itemsEl = btn.closest(ITEMS);
    var lineList = document.getElementById(prefix + '-CartItems');
    if (lineList && lineList.classList.contains('cart__items--disabled')) return;

    var line = parseInt(btn.dataset.line, 10);
    var qty = parseInt(btn.dataset.qty, 10);
    var plan = parseInt(btn.dataset.plan, 10);
    if (!line || !qty || !plan) return;

    var sectionId = ctx === 'drawer' ? 'cart-drawer' : (itemsEl && itemsEl.dataset.sectionId);
    if (!sectionId) return;

    var offer = btn.dataset.kind === '30' ? '30_to_90' : 'onetime_to_90';
    var info = {
      offer: offer,
      value_before: cents(btn.dataset.valueBefore),
      value_after: cents(btn.dataset.valueAfter),
      to_qty: qty,
      context: ctx
    };

    function render(html) {
      return ctx === 'drawer' ? renderDrawerFromSection(html) : renderPageFromSection(itemsEl, html);
    }

    busy = true;
    window.hgCartSwitching = true;
    if (lineList) lineList.classList.add('cart__items--disabled');
    if (itemsEl) itemsEl.hgUpdatedAt = (window.hgCartSeq = (window.hgCartSeq || 0) + 1);
    setLoading(btn, true);
    btn.setAttribute('aria-checked', 'true');
    track('hg_cart_offer_click', info);

    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var abortTimer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
    fetch((window.routes && window.routes.cart_change_url) || '/cart/change', {
      method: 'POST',
      signal: ctrl ? ctrl.signal : undefined,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: qty,
        selling_plan: plan,
        sections: [sectionId],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        var data = res.data || {};
        if (!res.ok || data.status || data.errors) {
          throw new Error(data.description || data.message || data.errors || 'switch failed');
        }
        var rendered = render(data.sections && data.sections[sectionId]);
        if (!rendered) {
          // Cart changed but the markup didn't come back: fetch it rather than show stale lines.
          return fetch(((window.routes && window.routes.cart_url) || '/cart') + '?section_id=' + encodeURIComponent(sectionId), { signal: ctrl ? ctrl.signal : undefined })
            .then(function (r) { return r.text(); })
            .then(function (html) { render(html); })
            .catch(function () { window.location.reload(); });
        }
      })
      .then(function () {
        track('hg_cart_offer_success', info);
        var live = document.getElementById(prefix + '-LiveRegionText');
        if (live) live.textContent = 'Switched to the 90-Day plan.';
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') {
          window.hgCartSwitching = false;
          window.location.reload();
          return;
        }
        btn.setAttribute('aria-checked', 'false');
        showError(btn, 'We couldn’t switch your plan just now. Your cart hasn’t changed — please try again.');
        setLoading(btn, false);
        if (document.body.contains(btn)) btn.focus();
        track('hg_cart_offer_error', { offer: offer, message: String(err && err.message || err), context: ctx });
      })
      .then(function () {
        busy = false;
        window.hgCartSwitching = false;
        if (abortTimer) clearTimeout(abortTimer);
        var list = document.getElementById(prefix + '-CartItems');
        if (list) list.classList.remove('cart__items--disabled');
        if (document.body.contains(btn)) setLoading(btn, false);
      });
  });

  // Drawer: report offers each time it opens (unchanged).
  document.addEventListener('hg:cart-opened', function () {
    setTimeout(function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !drawer.classList.contains('active')) return;
      reportOffersShown(document.getElementById('CartDrawer'));
    }, 400);
  });

  // Dawn's stepper/trash re-renders replace the cart markup too: keep a dismissed
  // 30-Day card dismissed after those, not only after our own renders. Observe every
  // cart root on the page (drawer and/or cart page); the page also reports its offers once.
  function init() {
    document.querySelectorAll(ROOT).forEach(function (root) {
      new MutationObserver(hideKeptCard).observe(root, { childList: true, subtree: true });
      if (contextOf(root) === 'page') setTimeout(function () { reportOffersShown(root); }, 400);
    });
    hideKeptCard();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Checkout never carries an unchecked typed quantity. Dawn validates a typed
  // quantity 300ms after the change, but clicking Checkout (or pressing Enter)
  // submits the form first, with the raw value. Every checkout form skips browser
  // validation (formnovalidate), so clean the values here: anything invalid
  // (not a number, negative, or not a multiple of the line's step) goes back to
  // the quantity the cart actually has. Forms: drawer, cart page, legacy Dawn /cart.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || (form.id !== 'CartDrawer-Form' && form.id !== 'CartPage-Form' && form.id !== 'cart')) return;
    form.querySelectorAll('.quantity__input').forEach(function (input) {
      var v = parseInt(input.value, 10);
      var step = parseInt(input.getAttribute('step'), 10) || 1;
      if (isNaN(v) || v < 0 || v % step !== 0) input.value = input.getAttribute('value');
    });
  }, true);
})();
